import { Builder } from '@builder.io/react'
import { HeadingClass, HeadingType } from 'enums'
import React from 'react'
import Bullet from '../../../images/BulletPoint.svg'
import LinkButton, { LinkButtonProp, LinkButtonRegisterProps } from '../common/button'
import CustomHeading, { headingTypePropObj, headingClassPropObj } from '../common/heading'

enum ImageSide {
  Left = 'left',
  Right = 'right'
}

interface Props {
  backgroundColor: string
  topicText: string
  topicTextColor: string
  topicTextEnabled: boolean
  headingText: string
  headingTextColor: string
  imgAltText: string
  // subText: string
  subTextPoints: { subPoint: string; subPointRichText: string }[]
  subTextColor: string
  imageSrc: any
  buttonOne: LinkButtonProp
  imageSide: ImageSide
  headingType: HeadingType
  headingClass: HeadingClass
  textOntopOnMobile: boolean
  button: boolean
  bulletPoint: any
  bulletAltText: string
  imageProperty: string
  belowNavbar: boolean
}

const CTATwo = ({
  backgroundColor,
  topicText,
  topicTextColor,
  topicTextEnabled,
  headingText,
  headingTextColor,
  imgAltText = '',
  // subText,
  subTextPoints,
  subTextColor,
  imageSrc,
  buttonOne,
  imageSide,
  headingType,
  headingClass,
  textOntopOnMobile,
  button,
  bulletPoint,
  bulletAltText = '',
  imageProperty,
  belowNavbar
}: Props) => {
  const getTopicText = () => {
    if (!topicTextEnabled) return null

    return (
      <h2 className="text-base font-semibold uppercase tracking-wider text-gray-300" style={{ color: topicTextColor }}>
        {topicText}
      </h2>
    )
  }

  const getContent = () => {
    if (imageSide === ImageSide.Left) {
      let topImageClassList = 'h-56 sm:h-72 md:absolute md:left-0 md:h-full md:w-1/2 hidden md:block' // will hide top image on mobile
      let bottomImageClassList = 'h-56 sm:h-72 md:absolute md:left-0 md:h-full md:w-1/2 md:hidden' // will show bottom image on mobile

      if (!textOntopOnMobile) {
        topImageClassList = 'h-56 sm:h-72 md:absolute md:left-0 md:h-full md:w-1/2'
        bottomImageClassList = 'h-56 sm:h-72 md:absolute md:left-0 md:h-full md:w-1/2 hidden'
      }

      return (
        <>
          <div className={topImageClassList}>
            <img
              className={`h-full w-full ${imageProperty}`}
              src={
                imageSrc ||
                'https://images.unsplash.com/photo-1525130413817-d45c1d127c42?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1920&q=60&blend=6366F1&sat=-100&blend-mode=multiply'
              }
              alt={imgAltText}
            />
          </div>
          <div className="relative mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
            <div className="md:ml-auto md:w-1/2 md:pl-10">
              {getTopicText()}
              {/* <p className="mt-2 text-white text-3xl font-bold tracking-tight sm:text-4xl" style={{ color: headingTextColor }}>{headingText}</p> */}
              <CustomHeading
                classList="mt-2 text-white tracking-tight"
                headingClass={headingClass}
                headingType={headingType}
                color={headingTextColor}
              >
                {headingText}
              </CustomHeading>
              {/* <div className="flex items-start">
                <img src={bulletPoint} alt="" className="mt-1 mr-3" />
                <p className="mt-3 text-lg text-gray-300" style={{ color: subTextColor }}>
                  {subText}
                </p>
              </div> */}

              <ul>
                {subTextPoints?.map(item => (
                  <li className="flex items-center">
                    <img src={bulletPoint} className="mt-1 mr-3" alt={bulletAltText} />
                    {!item?.subPointRichText && (
                      <p className="mt-3 text-lg text-gray-300" style={{ color: subTextColor }}>
                        {item?.subPoint}
                      </p>
                    )}
                    {item?.subPointRichText && (
                      <div
                        className="mt-3 text-lg"
                        style={{ color: subTextColor }}
                        dangerouslySetInnerHTML={{ __html: item?.subPointRichText }}
                      />
                    )}
                  </li>
                ))}
              </ul>
              {button && (
                <div className="mt-8 flex justify-center sm:justify-start">
                  <div className="inline-flex rounded-full shadow">
                    {buttonOne && (
                      <LinkButton
                        buttonColor={buttonOne.buttonColor}
                        buttonText={`${buttonOne.buttonText} `}
                        buttonTextColor={buttonOne.buttonTextColor}
                        loggedInButtonText={buttonOne.loggedInButtonText}
                        buttonUrl={buttonOne.buttonUrl}
                        isLink={buttonOne.isLink}
                        classList={
                          'inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-full text-gray-900 bg-white hover:bg-gray-50'
                        }
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className={bottomImageClassList}>
            <img
              className={`h-full w-full ${imageProperty}`}
              src={
                imageSrc ||
                'https://images.unsplash.com/photo-1525130413817-d45c1d127c42?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1920&q=60&blend=6366F1&sat=-100&blend-mode=multiply'
              }
              alt={imgAltText}
            />
          </div>
        </>
      )
    }

    return (
      <>
        <div className="relative mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
          <div className="md:mr-auto md:w-1/2 md:pr-10">
            {getTopicText()}
            {/* <p className="mt-2 text-white text-3xl font-bold tracking-tight sm:text-4xl" style={{ color: headingTextColor }}>{headingText}</p> */}
            <CustomHeading
              classList="mt-2 text-white font-bold tracking-tight"
              headingClass={headingClass}
              headingType={headingType}
              color={headingTextColor}
            >
              {headingText}
            </CustomHeading>
            <ul>
              {subTextPoints?.map(item => (
                <li className="flex items-center">
                  <img src={bulletPoint} alt={bulletAltText} className="mt-1 mr-3" />
                  {!item?.subPointRichText && (
                    <p className="mt-3 text-lg text-gray-300" style={{ color: subTextColor }}>
                      {item?.subPoint}
                    </p>
                  )}
                  {item?.subPointRichText && (
                    <div
                      className="mt-3 text-lg"
                      style={{ color: subTextColor }}
                      dangerouslySetInnerHTML={{ __html: item?.subPointRichText }}
                    />
                  )}
                </li>
              ))}
            </ul>
            {button && (
              <div className="mt-8 flex justify-center sm:justify-start">
                <div className="inline-flex rounded-full shadow">
                  {buttonOne && (
                    <LinkButton
                      buttonColor={buttonOne.buttonColor}
                      buttonText={`${buttonOne.buttonText} `}
                      buttonTextColor={buttonOne.buttonTextColor}
                      loggedInButtonText={buttonOne.loggedInButtonText}
                      buttonUrl={buttonOne.buttonUrl}
                      isLink={buttonOne.isLink}
                      classList={
                        'inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-full text-gray-900 bg-white hover:bg-gray-50'
                      }
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="h-56 sm:h-72 md:absolute md:right-0 md:top-0 md:h-full md:w-1/2">
          <img
            className={`h-full w-full ${imageProperty}`}
            src={
              imageSrc ||
              'https://images.unsplash.com/photo-1525130413817-d45c1d127c42?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1920&q=60&blend=6366F1&sat=-100&blend-mode=multiply'
            }
            alt={imgAltText}
          />
        </div>
      </>
    )
  }

  return (
    <div
      className={`relative bg-gray-800 ${belowNavbar ? 'lg:-mt-12' : ''}`}
      style={{ backgroundColor: backgroundColor }}
    >
      {getContent()}
    </div>
  )
}

export default CTATwo

Builder.registerComponent(CTATwo, {
  name: 'CTATwo',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'topicTextEnabled',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'topicText',
      type: 'text',
      defaultValue: 'Join our team'
    },
    {
      name: 'topicTextColor',
      type: 'color',
      defaultValue: 'gray'
    },
    {
      ...headingTypePropObj
    },
    {
      ...headingClassPropObj
    },
    {
      name: 'headingText',
      type: 'text',
      defaultValue: 'Join our team'
    },
    {
      name: 'headingTextColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'imageSrc',
      type: 'file',
      defaultValue: null
    },
    {
      name: 'imgAltText',
      type: 'text',
      defaultValue: ''
    },
    {
      ...LinkButtonRegisterProps,
      name: 'buttonOne'
    },
    {
      name: 'imageSide',
      type: 'string',
      enum: ['left', 'right'],
      defaultValue: 'left'
    },
    {
      name: 'textOntopOnMobile',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'button',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'subTextPoints',
      type: 'list',
      subFields: [
        { name: 'subPoint', type: 'text', defaultValue: 'Better digestion and healthier gut' },
        {
          name: 'subPointRichText',
          type: 'richText',
          defaultValue: ''
        }
      ]
    },
    {
      name: 'subTextColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'bulletPoint',
      type: 'file',
      defaultValue: Bullet
    },
    {
      name: 'bulletAltText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'imageProperty',
      type: 'string',
      enum: ['object-contain', 'object-cover'],
      defaultValue: 'object-contain'
    },
    {
      name: 'belowNavbar',
      type: 'boolean',
      defaultValue: false
    }
  ]
})
